import marqii from '@/assets/images/marqii.svg'
import { ConditionalComponent } from '@/components/ConditionalComponent/ConditionalComponent'
import { Image } from '@/components/Image'
import { ImpersonatingBanner } from '@/components/ImpersonatingBanner'
import { UserProfileDropdown } from '@/components/layouts/Header/UserProfileDropdown'
import { PaymentIssueWarningBanner } from '@/components/PaymentIssueWarningBanner/PaymentIssueWarningBanner'
import { Space } from '@/components/Space'
import { PATHS } from '@/routes/PATHS'
import { usePremiumFeaturesStatus } from '@/stores/permissions/premiumFeatures'
import { Layout } from 'antd'
import { Link } from 'react-router'
import { BeamerWidget } from './Beamer/BeamerWidget'
import styles from './styles.module.scss'

export const HEADER_TEST_ID = 'header-test-id'

export function Header() {
  const premiumFeaturesStatus = usePremiumFeaturesStatus()

  const shouldBlockAccount = premiumFeaturesStatus && premiumFeaturesStatus === 'SUSPENDED'

  const shouldShowBeamer = !shouldBlockAccount

  return (
    <div>
      <ImpersonatingBanner />
      <PaymentIssueWarningBanner />

      <Layout.Header data-testid={HEADER_TEST_ID} className={styles.header}>
        <Link to={PATHS.homePage}>
          <Space align="center">
            <Image src={marqii} width="100px" />
          </Space>
        </Link>
        <ConditionalComponent condition={shouldShowBeamer}>
          <BeamerWidget className={styles.beamerWidget} />
        </ConditionalComponent>
        <UserProfileDropdown />
      </Layout.Header>
    </div>
  )
}
